import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import translationEN from "./locales/en/translation.json";
import translationAR from "./locales/AR/translation.json";
import translationITA from "./locales/ITA/translation.json";

const resources = {
  en: { translation: translationEN },
  ar: { translation: translationAR },
  it: { translation: translationITA },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    interpolation: { escapeValue: false },
  });

export default i18n;
